var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-6",staticStyle:{"padding-right":"0"}},[_c('vc-date-picker',{attrs:{"locale":"nl-NL"},on:{"input":function($event){return _vm.emitToggleEvent()}},model:{value:(_vm.filter.value),callback:function ($$v) {_vm.$set(_vm.filter, "value", $$v)},expression:"filter.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }